import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFile from '../Shared/ChunkedUploadFile';
import './SpaceUpTwoUploadFile.css';

const SPACE_UP_TWO_ROOT =
  process.env.REACT_APP_SPACEUPTWO_START_PATH || '/spaceup-two';

function SpaceUpTwoUploadFile({ currentPath, userId, onFileUploaded }) {
  return (
    <ChunkedUploadFile
      currentPath={currentPath}
      userId={userId}
      onFileUploaded={onFileUploaded}
      rootPath={SPACE_UP_TWO_ROOT}
      sessionPrefix="space_up_two_file"
    />
  );
}

SpaceUpTwoUploadFile.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFileUploaded: PropTypes.func,
};

export default SpaceUpTwoUploadFile;
